<!--  -->
<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <!-- <el-table-column
        prop="id"
        label="ID"
        width="50"
        align="center"
      /> -->
      <el-table-column
        prop="send_time"
        label="发送时间"
        width="180"
        align="center"
      />
      <el-table-column
        prop="send_status_str"
        label="发送状态"
        width="180"
        align="center"
      />

      <el-table-column
        prop="tries"
        label="尝试次数"
        align="center"
      />
      <el-table-column
        prop="message"
        label="发送内容"
        align="center"
      />
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { payrecordr } from '@/api/providerAccountManagement/servicePorviderList2.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      queryr: {
        page: 1,
        page_size: 10
      },
      total: null,
      tableData: [],
      id: null
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    async customeoncallback(ids) {
      this.id = ids
      const id = this.id
      const data = await payrecordr(id, this.queryr)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data.data.list)
    },
    // 分页
    fetchPageSize(e) {
      console.log('this.id', this.id)
      this.queryr.page_size = e
      this.customeoncallback(this.id)
    },
    fetchCurrentPage(e) {
      console.log('this.id', this.id)
      this.queryr.page = e
      this.customeoncallback(this.id)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
